import { call, put } from 'redux-saga/effects';

import api from 'api';

import { sendTemporaryPassword, sendTemporaryPasswordError, sendTemporaryPasswordSuccess } from '../actions';
import { notifySuccess } from '../../notifications/actions';

import { LS_KEYS } from 'helpers/localStorage';

export function* sendTemporaryPasswordSaga({ payload }: ReturnType<typeof sendTemporaryPassword>) {
    const { email, onSuccess, onError } = payload;
    const isContactUsVisible = Boolean(localStorage.getItem(LS_KEYS.showTmpPasswordContactUs));

    try {
        yield call(api.auth.sendTemporaryPassword, { email });

        localStorage.setItem(LS_KEYS.tmpPasswordEmail, email);

        if (onSuccess) yield call(onSuccess);

        if (isContactUsVisible) {
            yield put(notifySuccess({ message: 'oneTimePassword.notification.newCodeSent', values: { email } }));
        }

        yield put(sendTemporaryPasswordSuccess());
    } catch (error: any) {
        yield put(sendTemporaryPasswordError());

        if (error.response?.status === 404) {
            if (onError) yield call(onError, 'message.error.emailNotFound');
        } else {
            if (onError) yield call(onError);
        }
    }
}
